import { AstNodeCategory, AstNodeType } from './node';
export class BlockStatement {
    constructor(token, statements = []) {
        this.token = token;
        this.statements = statements;
        this.nodeType = AstNodeType.BlockStatement;
        this.nodeCategory = AstNodeCategory.Statement;
    }
    get Statements() {
        return this.statements;
    }
    set Statements(val) {
        this.statements = val;
    }
    addStatement(stmt) {
        this.statements.push(stmt);
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return this.statements.map((s) => s.toString()).join('\n');
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmxvY2tTdGF0ZW1lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2FzdC9CbG9ja1N0YXRlbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsZUFBZSxFQUFFLFdBQVcsRUFBYSxNQUFNLFFBQVEsQ0FBQztBQUVqRSxNQUFNLE9BQU8sY0FBYztJQUN2QixZQUFvQixLQUFZLEVBQVUsYUFBMEIsRUFBRTtRQUFsRCxVQUFLLEdBQUwsS0FBSyxDQUFPO1FBQVUsZUFBVSxHQUFWLFVBQVUsQ0FBa0I7UUFFdEUsYUFBUSxHQUFnQixXQUFXLENBQUMsY0FBYyxDQUFDO1FBQ25ELGlCQUFZLEdBQW9CLGVBQWUsQ0FBQyxTQUFTLENBQUM7SUFIZSxDQUFDO0lBSzFFLElBQUksVUFBVTtRQUNWLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQztJQUMzQixDQUFDO0lBRUQsSUFBSSxVQUFVLENBQUMsR0FBRztRQUNkLElBQUksQ0FBQyxVQUFVLEdBQUcsR0FBRyxDQUFDO0lBQzFCLENBQUM7SUFFRCxZQUFZLENBQUMsSUFBSTtRQUNiLElBQUksQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQy9CLENBQUM7SUFFRCxZQUFZO1FBQ1IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQztJQUM5QixDQUFDO0lBRUQsUUFBUTtRQUNKLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMvRCxDQUFDO0NBQ0oifQ==